import api from './api';
import API_ROUTES from './apiRoutes';

const playerProfileService = {
  getProfile: async () => {
    const response = await api.get(API_ROUTES.PLAYER.PROFILE);
    return response.data;
  },

  updateProfile: async (profileData) => {
    const response = await api.patch(API_ROUTES.PLAYER.PROFILE, profileData);
    return response.data;
  },

  // Video APIs
  uploadVideo: async (videoFile) => {
    const formData = new FormData();
    formData.append('videos', videoFile);
    const response = await api.post(API_ROUTES.PLAYER.VIDEOS, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      timeout: 300000, // 5 minutes for video upload
    });
    return response.data;
  },

  deleteVideo: async (videoId) => {
    const response = await api.delete(API_ROUTES.PLAYER.DELETE_VIDEO(videoId));
    return response.data;
  },

  // Recommendation APIs
  uploadRecommendation: async (recommendationFile) => {
    const formData = new FormData();
    formData.append('recommendation', recommendationFile);
    const response = await api.post(API_ROUTES.PLAYER.RECOMMENDATION, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  deleteRecommendation: async () => {
    const response = await api.delete(API_ROUTES.PLAYER.DELETE_RECOMMENDATION);
    return response.data;
  },

  // Strengths APIs
  addStrength: async (strength) => {
    const response = await api.post(API_ROUTES.PLAYER.STRENGTHS, { strength });
    return response.data;
  },

  deleteStrength: async (strength) => {
    const response = await api.delete(API_ROUTES.PLAYER.DELETE_STRENGTH, {
      data: { strength },
    });
    return response.data;
  },

  // Awards APIs
  addAward: async (award) => {
    const response = await api.post(API_ROUTES.PLAYER.AWARDS, { award });
    return response.data;
  },

  deleteAward: async (award) => {
    const response = await api.delete(API_ROUTES.PLAYER.DELETE_AWARD, {
      data: { award },
    });
    return response.data;
  },

  // Profile Image APIs
  updateProfileImage: async (imageFile) => {
    const formData = new FormData();
    formData.append('profileImage', imageFile);
    const response = await api.patch(API_ROUTES.PLAYER.PROFILE_IMAGE, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  deleteProfileImage: async () => {
    const response = await api.delete(API_ROUTES.PLAYER.DELETE_PROFILE_IMAGE);
    return response.data;
  },

  // Academic Info APIs
  uploadAcademicInfo: async (pdfFile) => {
    const formData = new FormData();
    formData.append('academicInfo', pdfFile);
    const response = await api.post(API_ROUTES.PLAYER.ACADEMIC_INFO, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  deleteAcademicInfo: async () => {
    const response = await api.delete(API_ROUTES.PLAYER.DELETE_ACADEMIC_INFO);
    return response.data;
  },

  // Team Roster API
  getTeamRoster: async (teamId, page = 1, limit = 20) => {
    const response = await api.get(API_ROUTES.PLAYER.TEAM_ROSTER(teamId, page, limit));
    return response.data;
  },

  // Get Player by ID
  getPlayerById: async (playerId) => {
    const response = await api.get(API_ROUTES.PLAYER.GET_BY_ID(playerId));
    return response.data;
  },
};

export default playerProfileService;
